import * as Y from 'yjs';

export const ROOM_CONTROL_MAP = 'roomControl';
export const ROOM_SWITCH_KEY = 'switchTo';

const HEAVY_DOC_BYTES = 500 * 1024;

export function formatBytes(n) {
  const v = Number(n) || 0;
  if (v < 1024) return `${v} Б`;
  if (v < 1024 * 1024) {
    const kb = v / 1024;
    return `${kb < 10 ? kb.toFixed(1) : Math.round(kb)} КБ`;
  }
  return `${(v / (1024 * 1024)).toFixed(1)} МБ`;
}

export function measureRoom(ydoc) {
  if (!ydoc) return null;
  let textChars = 0;
  try {
    textChars = ydoc.getText('codemirror').length;
  } catch {
    textChars = 0;
  }
  let docBytes = 0;
  try {
    docBytes = Y.encodeStateAsUpdate(ydoc).byteLength;
  } catch {
    docBytes = 0;
  }
  return { textChars, docBytes };
}

export function roomSizeLabel(stats) {
  if (!stats) return '';
  const chars = (Number(stats.textChars) || 0).toLocaleString('ru-RU');
  return `код ${chars} · док ${formatBytes(stats.docBytes)}`;
}

export function roomLooksHeavy(stats) {
  return Boolean(stats && stats.docBytes >= HEAVY_DOC_BYTES);
}

export function roomSizeTitle(stats) {
  const base = 'Код — символы в редакторе. Документ — вес комнаты вместе с историей правок. Обновление раз в 15 с.';
  if (!roomLooksHeavy(stats)) return base;
  return `${base} Документ тяжёлый: история правок раздулась.`;
}

export function snapshotRoom(ydoc) {
  const text = (() => {
    try {
      return ydoc.getText('codemirror').toString();
    } catch {
      return '';
    }
  })();
  const workspace = {};
  try {
    ydoc.getMap('workspace').forEach((value, key) => {
      if (!value || typeof value !== 'object') return;
      try {
        workspace[key] = JSON.parse(JSON.stringify(value));
      } catch {
        // не копируем то, что не сериализуется в обычный JSON
      }
    });
  } catch {
    // нет карты workspace
  }
  return { text, workspace };
}

export function announceRoomSwitch(ydoc, nextSessionId) {
  if (!ydoc || !nextSessionId) return;
  ydoc.getMap(ROOM_CONTROL_MAP).set(ROOM_SWITCH_KEY, String(nextSessionId));
}

export function readRoomSwitch(ydoc) {
  if (!ydoc) return '';
  try {
    const next = ydoc.getMap(ROOM_CONTROL_MAP).get(ROOM_SWITCH_KEY);
    return typeof next === 'string' ? next : '';
  } catch {
    return '';
  }
}

/** Вписать текущий текст в пустую комнату, без старой истории. */
export function seedFreshRoom(ydoc, snapshot) {
  if (!ydoc || !snapshot) return;
  const ytext = ydoc.getText('codemirror');
  const ymap = ydoc.getMap('workspace');
  ydoc.transact(() => {
    if (ytext.length === 0 && snapshot.text) {
      ytext.insert(0, snapshot.text);
    }
    Object.entries(snapshot.workspace || {}).forEach(([key, value]) => {
      ymap.set(key, value);
    });
  });
}
